import { Alert, Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import OtherIncomeForm from './OtherIncomeForm';
import ShareProfitIncomeForm from './ShareProfitIncomeForm';

const OtherIncome = () => {
  return (
    <Box mt={6}>
      <Typography fontWeight={800}>รายได้อื่น ตามที่ระบุในงบการเงิน</Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        <Flex>
          คำชี้แจง :
          <Box pl={1}>
            <ul style={{ paddingLeft: 16, margin: 0 }}>
              <li>ถ้าไม่มีรายได้อื่น กรุณากรอก 0</li>
              <li>
                กรณีรายได้อื่นจากการดำเนินงาน หรือ นอกเหนือจากการดำเนินงาน
                มีนัยสำคัญ กรุณาแจกแจงรายได้ (ถ้ามี)
              </li>
            </ul>
          </Box>
        </Flex>
      </Alert>
      <OtherIncomeForm />
      <Typography fontWeight={'bold'} mt={6}>
        ส่วนแบ่งกำไร (ขาดทุน) ของการร่วมค้าและบริษัทร่วมตามวิธีส่วนได้เสีย
        (ถ้ามี)
      </Typography>
      <ShareProfitIncomeForm />
    </Box>
  );
};

export default OtherIncome;
